import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment';
import {getTableRowClass,formatAsMoney} from "../WireTransfer/utils/utils"
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Pagination from "@material-ui/lab/Pagination";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82"
},
redText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#D91A1A"
},
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  }
}));

function TriggersHistoricTable(props) {
    const classes = useStyles();
    useTheme();

    const {alert_triggers} = props

    const groupedTriggers = alert_triggers.reduce((acc, trigger) => {
        const groupKey = trigger.trigger_group.source_evaluated_object_key;

        if (!acc[groupKey]) {
            acc[groupKey] = {
                groupData: trigger.trigger_group,
                count: 1
            };
        } else {
            acc[groupKey].count += 1;
        }

        return acc;
    }, {});
    
    
    const alertTriggersGroupFormatted = Object.values(groupedTriggers);

    const [page, setPage] = useState(0);
    const rowsPerPage = 10

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1); 
    }
    const pageCount = Math.ceil(alertTriggersGroupFormatted.length / rowsPerPage);
    

    const getTriggerEventTypeUrl = (eventType) => {
        switch (eventType) {
            case 'card_order':
                return '/card-order-alert/'
            case 'bankslip':
                return '/bankslip/'
            case 'bill_payment':
                return '/bill-payment/'
            case 'wire_transfer':
                return "/wire-transfer/"
            case 'withdrawal':
                return '/withdrawal/'
            case 'pix_transaction':
                return '/pix-transaction/'
            case 'pix_dict_operation':
                return '/pix-dict/'
            case 'currency_exchange_operation':
                return '/account-monitoring-alert/'
            case 'ofac':
                return '/account-monitoring-alert/'
            case 'unsc':
                return '/account-monitoring-alert/'
            case 'pep':
                return '/account-monitoring-alert/'
            case 'ceis':
                return '/account-monitoring-alert/'
            case 'cnep':
                return '/account-monitoring-alert/'
            case 'ibama':
                return '/account-monitoring-alert/'
            case 'receita_federal_status':
                return '/account-monitoring-alert/'
            case 'receita_federal_name':
                return '/account-monitoring-alert/'
            case 'delorean':
                return '/account-monitoring-alert/'
            default:
                return ''
        }
    }

    const getTriggerEventTypeEnum = (eventType) => {
        switch (eventType) {
            case 'card_order':
                return 'Cartão'
            case 'bankslip':
                return 'Boleto'
            case 'bill_payment':
                return 'Pagamento de Conta'
            case 'wire_transfer':
                return "Transferência"
            case 'withdrawal':
                return 'Saque'
            case 'pix_transaction':
                return 'Pix'
            case 'pix_dict_operation':
                return 'Dict'
            case 'currency_exchange_operation':
                return 'Monitoramento de Conta'
            case 'ofac':
                return 'Monitoramento de Conta'
            case 'unsc':
                return 'Monitoramento de Conta'
            case 'pep':
                return 'Monitoramento de Conta'
            case 'ceis':
                return 'Monitoramento de Conta'
            case 'cnep':
                return 'Monitoramento de Conta'
            case 'ibama':
                return 'Monitoramento de Conta'
            case 'receita_federal_status':
                return 'Monitoramento de Conta'
            case 'receita_federal_name':
                return 'Monitoramento de Conta'
            case 'delorean':
                return 'Monitoramento de Conta'
            default:
                return ''
        }
    }

    return (
        <Paper className={classes.tableStyle}>
            <Table style={{ padding: "8px" }}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHeader}>ID</TableCell>
                        <TableCell className={classes.tableHeader}>Gatilhos</TableCell>
                        <TableCell className={classes.tableHeader}>Valor</TableCell>
                        <TableCell className={classes.tableHeader}>Tipo</TableCell>
                        <TableCell className={classes.tableHeader}>Data</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {alertTriggersGroupFormatted
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((triggerGroup, index) => (
                    <TableRow
                        key={index}
                        className={getTableRowClass(index)}
                    > 
                        <TableCell
                            className={[classes.tableText, classes.blueText, "breakWord", "link"].join(" ")}
                        >
                            <Link
                                className="linkRed"
                                to={getTriggerEventTypeUrl(triggerGroup.groupData.event_type) + triggerGroup.groupData.source_evaluated_object_key}
                            >
                                <Tooltip title={<p className="tooltipText">Transação responsável por um trigger</p>}>
                                    <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                                        <ErrorOutlineIcon style={{color:"#D91A1A", width:"18px", marginRight: "5px"}}/>
                                        {triggerGroup.groupData.source_evaluated_object_key}
                                    </div>
                                </Tooltip>
                            </Link>
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            {triggerGroup.count || "-"}
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            {formatAsMoney(triggerGroup.groupData.amount, "-")}
                        </TableCell>
                        <TableCell className={[classes.tableText].join(" ")}>
                            {getTriggerEventTypeEnum(triggerGroup.groupData.event_type)}
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            {moment(triggerGroup.groupData.occurrence_date).format("DD/MM/YYYY HH:mm:ss")}
                        </TableCell>
                        <TableCell className={classes.tableText}>

                        </TableCell>    
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
            <div style={{display:"flex", marginTop: "10px"}}>
                <Pagination 
                    style={{marginLeft:"auto"}} 
                    className='pagination' 
                    count={pageCount} 
                    page={page + 1} 
                    onChange={handleChangePage}
                />
            </div>
        </Paper>
    );
}

export default TriggersHistoricTable;
